import {
  CloseButton,
  FileUpload,
  Flex,
  Input,
  Text,
} from "@chakra-ui/react";
import { LuFileUp } from "react-icons/lu";
import { InputGroup } from "./ui/input-group";
import ButtonComp from "./Button";

let w = "12rem";
// maxWidth="300px"

const FileUploadComp = ({
  filename,
  onChange,
  onUpload,
  label,
  variant,
  accept,
}) => {
  if (variant === "button") {
    return (
      <Flex direction={"row"}>
        <FileUpload.Root
          onChange={(e) => {
            e.stopPropagation();
            if (onUpload) {
              onUpload(e.target.files[0]);
            }
          }}
          accept={accept}
        >
          <FileUpload.HiddenInput />
          <FileUpload.Trigger asChild>
            <ButtonComp keyname="upload-ic" />
            {/* <IoIosAddCircleOutline size={"2rem"} /> */}
          </FileUpload.Trigger>
          {/* <FileUpload.List /> */}
        </FileUpload.Root>
      </Flex>
    );
  }

  return (
    <Flex direction={"row"}>
      <FileUpload.Root gap="1" w={w} accept={accept}>
        <FileUpload.HiddenInput
          onChange={(e) => onChange && onChange(e.target.files[0])}
        />
        {/* <FileUpload.Label>Upload file</FileUpload.Label> */}
        <InputGroup
          startElement={<LuFileUp />}
          endElement={
            <FileUpload.ClearTrigger asChild>
              <CloseButton
                me="-1"
                size="xs"
                variant="plain"
                focusVisibleRing="inside"
                focusRingWidth="2px"
                pointerEvents="auto"
              />
            </FileUpload.ClearTrigger>
          }
        >
          <Input
            w={w}
            asChild
            value={{
              maxFiles: 1,
              maxFileSize: 3000,
            }}
          >
            <FileUpload.Trigger>
              {filename ? (
                <Text lineClamp={1}>{filename}</Text>
              ) : (
                <Text lineClamp={1} color={"gray.500"}>
                  {"select file"}
                </Text>
              )}
              {/* <FileUpload.FileText lineClamp={1} /> */}
            </FileUpload.Trigger>
          </Input>
        </InputGroup>
      </FileUpload.Root>

      <ButtonComp
        label={label || "Upload"}
        keyname="upload-ic"
        onClick={onUpload}
        disabled={!filename}
      />
    </Flex>
  );
};

export default FileUploadComp;
